<template>
  <div>
    <el-dialog
        class="customerSnRuleEdit"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="snRule.pkid > 0 ? '编辑' : '新建'"
        width="800px"
        top="10vh"
        @close="$reset('form')">
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="snRule"
          :rules="ruleValidate"
          class="form"
          label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="标签编号" prop="materialSnRuleNo" style="height: 28px">
              <el-input v-model="snRule.materialSnRuleNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="snRule.customerName" placeholder="请选择客户" readonly>
                <el-button slot="append" @click="$refs.selectCustomer.open()"> 选择 </el-button>
              </el-input>
              <customer-select ref="selectCustomer" @select="selectCustomer"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料编号" prop="materialNo">
              <el-input v-model="snRule.materialNo" placeholder="请选择物料" readonly>
                <el-button slot="append" @click="$refs.selectMaterialNo.open()"> 选择 </el-button>
              </el-input>
              <material-select ref="selectMaterialNo" @select="selectMaterialNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="条码编号" prop="snRuleNo">
              <el-input v-model="snRule.snRuleNo" placeholder="请选择条码规则" readonly>
                <el-button slot="append" @click="$refs.selectSnRuleNo.open()"> 选择 </el-button>
              </el-input>
              <bar-code-rules-select ref="selectSnRuleNo" @select="selectSnRuleNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="版本号" prop="snVersion">
              <el-input v-model="snRule.snVersion" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="snRule.status" placeholder="请选择状态">
                <el-option v-for="item in snStatus" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">详细信息</div>
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.editDetailsPage.open(0, -1)"> 新建 </el-button>
      <el-table border :data="tableData">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="metaDataNo" align="center" label="标签"/>
        <el-table-column prop="metaDataValue" align="center" label="值"/>
        <el-table-column label="操作" align="center" width="120px">
          <template slot-scope="scope">
            <el-button type="primary" @click="$refs.editDetailsPage.open(scope.row, scope.$index)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
    <customer-sn-rule-details-edit ref="editDetailsPage" @save-success="getList"/>
  </div>
</template>

<script>
  import CustomerSnRuleDetailsEdit from "@/views/information/CustomerSnRule/CustomerSnRuleDetailsEdit";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import BarCodeRulesSelect from "@/views/information/BarCodeRules/BarCodeRulesSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "CustomerSnRuleEdit",
    components: { BarCodeRulesSelect, MaterialSelect, CustomerSnRuleDetailsEdit ,CustomerSelect},
    props: {
      snStatus: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        snRule: {
          pkid: "",
          materialSnRuleNo: "",
          materialNo: "",
          materialId: "",
          customerId:"",
          snRuleNo: "",
          snRuleId: "",
          snVersion: "",
          status: "",
          snCustomerSnRuleDetailList: [],
          materialName: "",
          customerName:"",
        },
        tableData: [],
        ruleValidate: {
          materialSnRuleNo: { required: true, message: "标签编号不能为空" },
          materialNo: { required: true, message: "请选择物料", trigger: "change" },
          customerName: { required: true, message: "请选择客户", trigger: "change" },
          snRuleNo: { required: true, message: "请选择条码规则", trigger: "change" },
          status: { required: true, message: "请选择状态", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.snRule.pkid = row.pkId;
          this.getData();
        } else {
          this.getLabelNo();
        }
      },

      // 获取标签编号
      getLabelNo() {
        this.$http.get("basic", "snCustomerSnRules/genno").then((resp) => {
          if (resp.success) {
            this.snRule.materialSnRuleNo = resp.data;
          }
        });
      },

      // 根据物料id获取版本号
      getVersionByMetrailId() {
        this.$http.get("basic", `snCustomerSnRules/version?materialId=${this.snRule.materialId}&customerId=${this.snRule.customerId}`).then((resp) => {
          if (resp.success) {
            this.snRule.snVersion = resp.data;
          }
        });
      },


      // 根据物料条码id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `snCustomerSnRules/${this.snRule.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.snRule = resp.data;
              this.tableData = this.snRule.snCustomerSnRuleDetailList;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      getList(row, index) {
        if (index >= 0) {
          this.tableData[index].pkid = row.pkid;
          this.tableData[index].rowIndex = index + 1;
          this.tableData[index].metaDataNo = row.metaDataNo;
          this.tableData[index].metaDataValue = row.metaDataValue;
          this.tableData[index].metaDataId = row.metaDataId;
        } else {
          this.tableData.push({
            pkid: 0,
            rowIndex: this.tableData.length + 1,
            metaDataNo: row.metaDataNo,
            metaDataValue: row.metaDataValue,
            metaDataId: row.metaDataId,
          });
        }
      },

      // 选择物料
      selectMaterialNo(row) {
        this.snRule.materialId = row.materialID;
        this.snRule.materialNo = row.materialNO;
        this.snRule.materialName = row.materialName;
        this.getVersionByMetrailId();
      },
      selectCustomer(row){
        this.snRule.customerId = row.customerID;
        this.snRule.customerName = row.customerName;
      },

      // 选择条码
      selectSnRuleNo(row) {
        this.snRule.snRuleNo = row.snRuleNo;
        this.snRule.snRuleId = row.pkid;
      },

      //详情表删除
      oneDelete(index) {
        this.tableData.splice(index, 1);
        //使tableData重新排序
        this.tableData.forEach((item, index) => {
          item.rowIndex = index + 1;
        });
      },

      // 提交(编辑/新建)
      handleSubmit() {
        this.snRule.snCustomerSnRuleDetailList = this.tableData;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "snCustomerSnRules", this.snRule)
              .then((resp) => {
                if (resp.success) {
                  if (this.snRule.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss">
.customerSnRuleEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.customerSnRuleEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.customerSnRuleEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.customerSnRuleEdit .el-divider--horizontal {
  margin: 10px 0;
}

.customerSnRuleEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>
